import moment, { Moment } from 'moment';

import { Sex } from 'app/model/Sex';
import { IdentityDocument } from 'app/model/IdentityDocument';
import { Employment } from 'app/model/Employment';
import { StreetAddress } from 'app/model/StreetAddress';
import { LocalityAddress } from 'app/model/LocalityAddress';
import {
    MarketingConsent,
    DEFAULT_MARKETING_CONSENT_LIST,
} from './MarketingConsent';

/**
 * Данные о клиенте банка
 */
export class Client {
    /**
     * Фамилия
     */
    surname: string;

    /**
     * Фамилия на латинице
     */
    surnameLatin: string;

    /**
     * Имя
     */
    name: string;

    /**
     * Имя на латинице
     */
    nameLatin: string;

    /**
     * Отчество
     */
    patronymic: string;

    /**
     * Дата рождения
     */
    birthDate: Moment;

    /**
     * Место рождения
     */
    birthPlace: LocalityAddress;

    /**
     * Пол
     */
    sex: Sex;

    /**
     * Документ, удостоверяющий личность
     */
    identity: IdentityDocument;

    /**
     * Гражданство (код страны)
     */
    citizenshipCountryCode: string;

    /**
     * Резидентство (код страны)
     */
    residencyCountryCode: string;

    /**
     * Номер мобильного телефона
     */
    mobilePhone: string;

    /**
     * Адрес электронной почты
     */
    email: string;

    /**
     * Адрес регистрации
     */
    registrationAddress: StreetAddress;

    /**
     * Адрес проживания
     */
    residentialAddress: StreetAddress;

    /**
     * Распространяется ли на клиента действие FATCA
     */
    isUnderFatca: boolean;

    /**
     * Сведения о работе
     */
    employment?: Employment;

    /**
     * Кодовое слово
     */
    secretWord: string;

    /**
     * Согласие на маркетинговую коммуникацию
     */
    isMarketingConsentSigned?: boolean;

    /**
     * Список согласий на каналы маркетинговой коммуникации
     */
    marketingConsentList?: MarketingConsent[];

    constructor(
        surname: string,
        surnameLatin: string,
        name: string,
        nameLatin: string,
        patronymic: string,
        birthDate: moment.Moment,
        birthPlace: LocalityAddress,
        sex: Sex,
        identity: IdentityDocument,
        citizenshipCountryCode: string,
        residencyCountryCode: string,
        mobilePhone: string,
        email: string,
        registrationAddress: StreetAddress,
        residentialAddress: StreetAddress,
        isUnderFatca: boolean,
        employment: Employment,
        secretWord: string,
        isMarketingConsentSigned: boolean,
        marketingConsentList: MarketingConsent[],
    ) {
        this.surname = surname;
        this.surnameLatin = surnameLatin;
        this.name = name;
        this.nameLatin = nameLatin;
        this.patronymic = patronymic;
        this.birthDate = birthDate;
        this.birthPlace = birthPlace;
        this.sex = sex;
        this.identity = identity;
        this.citizenshipCountryCode = citizenshipCountryCode;
        this.residencyCountryCode = residencyCountryCode;
        this.mobilePhone = mobilePhone;
        this.email = email;
        this.registrationAddress = registrationAddress;
        this.residentialAddress = residentialAddress;
        this.isUnderFatca = isUnderFatca;
        this.employment = employment;
        this.secretWord = secretWord;
        this.isMarketingConsentSigned = isMarketingConsentSigned;
        this.marketingConsentList =
            marketingConsentList || DEFAULT_MARKETING_CONSENT_LIST;
    }

    static withPersonalData(
        identity: IdentityDocument | null,
        mobilePhone: string,
    ) {
        return new Client(
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            identity,
            null,
            null,
            mobilePhone,
            null,
            null,
            null,
            null,
            null,
            null,
            false,
            null,
        );
    }

    static deserialize(data: any) {
        return !!data
            ? new Client(
                  data.surname,
                  data.surnameLatin,
                  data.name,
                  data.nameLatin,
                  data.patronymic,
                  moment(data.birthDate),
                  LocalityAddress.deserialize(data.birthPlace),
                  data.sex,
                  IdentityDocument.deserialize(data.identity),
                  data.citizenshipCountryCode,
                  data.residencyCountryCode,
                  data.mobilePhone,
                  data.email,
                  StreetAddress.deserialize(data.registrationAddress),
                  StreetAddress.deserialize(data.residentialAddress),
                  data.isUnderFatca,
                  Employment.deserialize(data.employment),
                  data.secretWord,
                  data.isMarketingConsentSigned,
                  data.marketingConsentList,
              )
            : null;
    }
}
